var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "home")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "Navigation",
    transform: "translate(-37.000000, -692.000000)",
    stroke: "var(--primaryTextColor)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.000000, 689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.45828364 C0,5.76479273 0.329687273,5.11260364 0.888109091,4.70139636 L7.27272727,0 L13.6573091,4.70140364 C14.2157818,5.11260364 14.5454545,5.76479273 14.5454545,6.45828364 L14.5454545,14.1818182 C14.5454545,15.1859636 13.7314182,16 12.7272727,16 L10.1818182,16 C9.78014545,16 9.45454545,15.6744 9.45454545,15.2727273 L9.45454545,10.9090909 C9.45454545,10.7082909 9.29170909,10.5454545 9.09090909,10.5454545 L5.45454545,10.5454545 C5.25371636,10.5454545 5.09090909,10.7082909 5.09090909,10.9090909 L5.09090909,15.2727273 C5.09090909,15.6744 4.76529455,16 4.36363636,16 L1.81818182,16 C0.814029091,16 0,15.1859636 0,14.1818182 L0,6.45828364 Z",
    id: "Path"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.544b9169.svg";
export { ForwardRef as ReactComponent };